import { Ammo } from '../physics'
import { physicsWorld } from '../physics'
import { scene } from '../utils'
import state from '../state'
import * as THREE from 'three'

export default function createRope(ballPos) {
  // Rope graphic object
  const ropeNumSegments = state.objects.rope.segments
  const ropeLength = state.objects.rope.length
  const ropeMass = state.objects.rope.mass
  //const ropePos = ball.position.clone()
  const ropePos = ballPos
  ropePos.y += state.objects.ball.radius

  const segmentLength = ropeLength / ropeNumSegments
  const ropeGeometry = new THREE.BufferGeometry()
  const ropeMaterial = new THREE.LineBasicMaterial({ color: 0x000000 })
  const ropePositions = []
  const ropeIndices = []

  for (let i = 0; i < ropeNumSegments + 1; i++) {
    ropePositions.push(ropePos.x, ropePos.y + i * segmentLength, ropePos.z)
  }

  for (let i = 0; i < ropeNumSegments; i++) {
    ropeIndices.push(i, i + 1)
  }

  ropeGeometry.setIndex(
    new THREE.BufferAttribute(new Uint16Array(ropeIndices), 1),
  )
  ropeGeometry.setAttribute(
    'position',
    new THREE.BufferAttribute(new Float32Array(ropePositions), 3),
  )
  ropeGeometry.computeBoundingSphere()
  const rope = new THREE.LineSegments(ropeGeometry, ropeMaterial)
  rope.castShadow = true
  rope.receiveShadow = true
  scene.add(rope)

  // Rope
  const softBodyHelpers = new Ammo.btSoftBodyHelpers()
  const ropeStart = new Ammo.btVector3(ropePos.x, ropePos.y, ropePos.z)
  const ropeEnd = new Ammo.btVector3(
    ropePos.x,
    ropePos.y + ropeLength,
    ropePos.z,
  )
  const ropeSoftBody = softBodyHelpers.CreateRope(
    physicsWorld.getWorldInfo(),
    ropeStart,
    ropeEnd,
    ropeNumSegments - 1,
    0,
  )
  const sbConfig = ropeSoftBody.get_m_cfg()
  sbConfig.set_viterations(10)
  sbConfig.set_piterations(10)
  ropeSoftBody.setTotalMass(ropeMass, false)
  Ammo.castObject(ropeSoftBody, Ammo.btCollisionObject)
    .getCollisionShape()
    .setMargin(state.physics.margin * 3)
  physicsWorld.addSoftBody(ropeSoftBody, 1, -1)
  rope.userData.physicsBody = ropeSoftBody

  // Disable deactivation
  ropeSoftBody.setActivationState(4)

  return { rope, ropePos, ropeSoftBody }
}
